import 'frontcore/styles'
import 'frontend/styles/main.scss'

import configureApplication from 'tscore/vue.config'
import i18n from 'frontcore/i18n'
import PortalVue from 'portal-vue'
import router from 'frontend/router'
import TheMain from 'frontend/TheMain.vue'
import { compatWarningHandler } from 'frontcore/utils/compatWarningHandler/compatWarningHandler'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { configureCompat, createApp } from 'vue'
import { createPinia } from 'pinia'
import { store } from 'frontend/store/store'
import { useCommunications } from 'tscore/communications'

const app = createApp(TheMain)

configureCompat({
  RENDER_FUNCTION: false,
})

app.config.performance = true

compatWarningHandler(app)

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
configureApplication(app)
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
useCommunications(app)

app.provide('vuex-store', store)

app
  .use(router)
  .use(store)
  .use(createPinia())
  .use(i18n)
  .use(PortalVue)
  .mount("#app")

// Compatibility config to avoid Vue 3 migration issues due to new lifecycle
app.config.globalProperties.$t = i18n.global.t
app.config.globalProperties.$tc = i18n.global.tc
